import { render, staticRenderFns } from "./RegisterApplicantInfo.vue?vue&type=template&id=30e7224c"
import script from "./RegisterApplicantInfo.vue?vue&type=script&lang=js"
export * from "./RegisterApplicantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports